import React from 'react';

import { CardExpiryElement } from '@stripe/react-stripe-js';
import type { StripeCardExpiryElementChangeEvent } from '@stripe/stripe-js';

type Props = {
	onChange?: (event: StripeCardExpiryElementChangeEvent) => unknown;
	onFocus?: () => void;
	onBlur?: () => void;
};

export function CardExpiryElementWrapper({ onChange, onFocus, onBlur }: Props): React.JSX.Element {
	return (
		<CardExpiryElement
			options={{ style: { base: { fontSize: '16px' } } }}
			onChange={onChange}
			onFocus={onFocus}
			onBlur={onBlur}
		/>
	);
}
